import { rServices } from '@/plugins/api';

import BaseModel from './base';

export default class PollQuestion extends BaseModel {
  constructor(question, url) {
    super(question, url);

    this.description = question.description || '';
    this.images = question.images || [];
    this.options = question.options || null;
    this.settings = question.settings || {};
    this.poll_id = question.poll_id;
    this.question_category_id = question.question_category_id;
    this.settings_id = question.settings_id;
    this.sort_order = question.sort_order;
    this.type = question.type;

    this.category = null;
  }

  async getCategory() {
    const { question_category_id } = this;
    if (!question_category_id) return {};
    const params = {
      'search[id]': question_category_id,
    };
    const { response, error } = await rServices.polls.getPollQuestionCategories({ params });
    this.category = response?.data?.data || {};
    return { ...response, ...error };
  }

  async uploadImages(names = []) {
    if (!names?.length) return {};
    const params = {
      images: names.map((name) => ({ name })),
    };
    const { response, error } = await rServices.polls.updatePollQuestionImages({ args: [this.id, params] });
    if (!error) {
      this.images = response?.data?.data || [];
    }
    return {
      ...response,
      ...error,
    };
  }

  async removeImages(ids = []) {
    await Promise.all(ids.map((id) => rServices.upload.deleteFile({ args: [id] }))).then(() => {
      this.images = this.images.filter((image) => !ids.includes(image.id));
    });
  }

  async updateSettings(params) {
    const { response, error } = await rServices.polls.updatePollQuestionSettings({ args: [this.settings_id, params] });
    if (!error) {
      this.settings = params;
    }
    return {
      ...response,
      ...error,
    };
  }
}
